module.exports = __webpack_public_path__ + "img/JF-XM.d2bec6ab.png";